export default function ClientTrainingPlansSection() {
  return <>Client - Training Plans</>;
}
